export let IntegrationAppIds;
(function (IntegrationAppIds) {
  IntegrationAppIds[IntegrationAppIds["QUICKBOOKS_QA"] = 1920452] = "QUICKBOOKS_QA";
  IntegrationAppIds[IntegrationAppIds["QUICKBOOKS_PROD"] = 542129] = "QUICKBOOKS_PROD";
  IntegrationAppIds[IntegrationAppIds["XERO_QA"] = 1208251] = "XERO_QA";
  IntegrationAppIds[IntegrationAppIds["XERO_PROD"] = 235997] = "XERO_PROD";
})(IntegrationAppIds || (IntegrationAppIds = {}));